export default __webpack_public_path__ + "static/media/banner-bg-small-ip.7afead69.png";